import { apiService } from './api';

export interface AssessmentNote {
  id: number;
  assessmentId: number;
  advisorId: number;
  noteType: string;
  content: string;
  questionId?: string;
  createdAt: string;
  advisor: {
    id: number;
    firstName: string;
    lastName: string;
  };
}

export interface CreateNoteData {
  noteType?: string;
  content: string;
  questionId?: string;
}

export interface UpdateNoteData {
  content: string;
  noteType?: string;
}

class AssessmentNotesService {
  async getAssessmentNotes(assessmentId: number): Promise<{ notes: AssessmentNote[] }> {
    return apiService.get(`/assessments/${assessmentId}/notes`);
  }

  async createNote(assessmentId: number, data: CreateNoteData): Promise<{ note: AssessmentNote }> {
    return apiService.post(`/assessments/${assessmentId}/notes`, data);
  }

  async updateNote(noteId: number, data: UpdateNoteData): Promise<{ note: AssessmentNote }> {
    return apiService.put(`/notes/${noteId}`, data);
  }

  async deleteNote(noteId: number): Promise<void> {
    return apiService.delete(`/notes/${noteId}`);
  }
}

export const assessmentNotesService = new AssessmentNotesService();
